export default "__VITE_ASSET__uS6aAPvs__"